import { render, staticRenderFns } from "./Cademi.vue?vue&type=template&id=4eb879c8&"
import script from "./Cademi.vue?vue&type=script&lang=js&"
export * from "./Cademi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports